import React from 'react';
import { Controller } from 'react-hook-form';
import { Card } from 'primereact/card';
import { Calendar } from 'primereact/calendar';
import AppConstants from 'constants/index';
import { convertDateFromApiToUserTimezone } from 'utils/utility_functions/timezone';
import { formatDOB, parseDOB } from 'modules/lead/helpers/helpers';

const ImportantDates = ({ control, userDetails, caseDetails, isCaseClosed, isLeadSpecific, caseReopenDate, caseClosedDate }) => {
  return (
    <>
      {!isLeadSpecific && (
        <div>
          <div className="caption-bold mb-3 mt-3">Important Dates</div>
          {/* imp dates */}
          <Card className="card-bg F-size14 mb-3">
            <>
              <div className="row mb-3 align-items-center">
                <div className="col-sm-6 text-muted p-medium">Statute of Limitation</div>
                <div className="col-sm-6 d-flex align-items-center edit-field">
                  <Controller
                    name="important_dates.statute_of_limitations"
                    control={control}
                    render={({ field }) => (
                      <Calendar
                        name={field.name}
                        monthNavigator
                        yearNavigator
                        yearRange="1900:2050"
                        showButtonBar
                        dateFormat={AppConstants.date_format}
                        value={field?.value ? parseDOB(field.value) : null}
                        onChange={(e) => {
                          const date = e.value;
                          if (date instanceof Date) {
                            field.onChange(formatDOB(date));
                          } else {
                            field.onChange(date || '');
                          }
                        }}
                        className="rounded flex-grow-1 w-75 input-shadow"
                        placeholder="Select SOL"
                        disabled={isCaseClosed}
                      />
                    )}
                  />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-sm-6 text-muted p-medium">Case Created</div>
                <div className="col-sm-6 d-flex align-items-center edit-field">
                  <div className="w-100 h-100">
                    {caseDetails?.important_dates?.case_created
                      ? convertDateFromApiToUserTimezone(
                          caseDetails?.important_dates?.case_created,
                          userDetails.userDetails.timezone,
                          AppConstants.month_date_year_format
                        )
                      : 'N/A'}
                  </div>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-sm-6 text-muted p-medium">Case Re-opened</div>
                <div className="col-sm-6 d-flex align-items-center edit-field">
                  <div className="w-100 h-100">
                    {caseReopenDate
                      ? convertDateFromApiToUserTimezone(
                          caseReopenDate,
                          userDetails?.userDetails?.timezone,
                          AppConstants.month_date_year_format
                        )
                      : 'N/A'}
                  </div>
                </div>
              </div>
              {isCaseClosed && (
                <div className="row mb-3">
                  <div className="col-sm-6 text-muted " style={{ fontWeight: 500 }}>
                    Case Closed
                  </div>
                  <div className="col-sm-6 d-flex align-items-center edit-field">
                    <div className="w-100 h-100">
                      {caseClosedDate
                        ? convertDateFromApiToUserTimezone(
                            caseClosedDate,
                            userDetails.userDetails.timezone,
                            AppConstants.month_date_year_format
                          )
                        : 'N/A'}
                    </div>
                  </div>
                </div>
              )}
              <div className="row mb-3">
                <div className="col-sm-6 text-muted p-medium">Client DOB</div>
                <div className="col-sm-6 d-flex align-items-center edit-field">
                  {/* <span>
                    {caseDetails?.client_details?.[0]?.dob ? formatDateWithoutTimezone(caseDetails?.client_details?.[0]?.dob) : ''}
                  </span> */}
                  <Controller
                    name="dob"
                    control={control}
                    render={({ field }) => (
                      <Calendar
                        name={field.name}
                        monthNavigator
                        yearNavigator
                        yearRange={`${new Date().getFullYear() - 100}:${new Date().getFullYear()}`}
                        showButtonBar
                        defaultValue={null}
                        dateFormat={AppConstants.date_format}
                        value={field?.value ? parseDOB(field?.value) : ''}
                        onChange={(e) => {
                          const date = e.value;
                          if (date instanceof Date) {
                            // Store as formatted date string (YYYY-MM-DD)
                            field.onChange(formatDOB(date));
                          }
                        }}
                        className="rounded flex-grow-1 w-75 input-shadow"
                        placeholder="N/A"
                        disabled={isCaseClosed}
                      />
                    )}
                  />
                </div>
              </div>
            </>
          </Card>
          {/* imp dates */}
        </div>
      )}
    </>
  );
};

export default ImportantDates;
